'use client';

import { mergeClasses, __styles } from '@griffel/react';
export const tableHeaderClassName = 'fui-TableHeader';
export const tableHeaderClassNames = {
  root: 'fui-TableHeader'
};
const useFlexLayoutStyles = /*#__PURE__*/__styles({
  root: {
    mc9l5x: "ftgm304"
  }
}, {
  d: [".ftgm304{display:block;}"]
});
const useTableLayoutStyles = /*#__PURE__*/__styles({
  root: {
    mc9l5x: "f1tp1avn"
  }
}, {
  d: [".f1tp1avn{display:table-row-group;}"]
});
/**
 * Apply styling to the TableHeader slots based on the state
 */
export const useTableHeaderStyles_unstable = state => {
  const layoutStyles = {
    table: useTableLayoutStyles(),
    flex: useFlexLayoutStyles()
  };
  // eslint-disable-next-line react-hooks/immutability
  state.root.className = mergeClasses(tableHeaderClassName, state.noNativeElements ? layoutStyles.flex.root : layoutStyles.table.root, state.root.className);
  return state;
};